<template>
    <div id="map-container" style="width: 100%; height: 100%;"></div>
  </template>
  
  <script setup>
  import { onMounted } from 'vue';
  import AMapLoader from '@amap/amap-jsapi-loader';
  
  const MAP_KEY = 'cd2c85e43cd8036e93ccbab491f571fc'; // 替换为你自己的高德地图 API Key
  
  onMounted(async () => {
    try {
      const AMap = await AMapLoader.load({
        key: MAP_KEY,
        version: '2.0',
        plugins: []
      });
  
      // 创建地图实例
      const map = new AMap.Map('map-container', {
        zoom: 16, // 地图缩放级别
        center: [113.462238,22.132369] // 地图中心点坐标
      });

      // 添加标记点
        const marker = new AMap.Marker({
        position: [113.462238,22.132369], // 标记点的坐标
        title: '珠海横琴融贯国际科技发展有限公司'
        });
        marker.setMap(map);
    } catch (error) {
      console.error('地图加载失败:', error);
    }
  });
  </script>
  
  <style scoped>
  #map-container {
    border: 1px solid #ccc;
  }
  </style>